<template>
  <div class="owner">
    <div class="titleWrap">
      <div class="setTitle">业主列表</div>
      <!-- <el-button class="myBtn" type="primary" plain size="small" style="margin-left: 10px;" :disabled="auditBackStatus" @click="auditBack">审核驳回</el-button>
      <el-button class="myBtn" type="primary" plain size="small" :disabled="auditPassStatus" @click="auditPass">审核通过</el-button> -->
      <el-button class="myBtn" type="primary" plain size="small" v-if="funcData.indexOf('export') > -1" @click="exportOwner" style="margin-left: 10px;">导出</el-button>
      <el-upload class="myBtn" :action="importOwnerUrl" :headers="myHeaders" :show-file-list="false" accept=".xls, .xlsx" :on-success="uploadSuccess" :on-error="uploadError" style="margin-left: 10px;">
        <el-button type="primary" plain size="small" v-if="villageId !== '' && funcData.indexOf('import') > -1">导入</el-button>
      </el-upload>
      <el-button class="myBtn" type="primary" plain size="small" v-if="villageId !== '' && funcData.indexOf('import') > -1" @click="templateOwner" style="margin-left: 10px;">业主模板</el-button>
      <el-button class="myBtn" type="primary" size="small" v-if="villageId !== '' && funcData.indexOf('add') > -1" @click="add">新增</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <div>
        <el-select class="select" v-model="villageValue" filterable size="small" placeholder="小区名称" @change="changeSearchVillage" v-if="villageId === ''">
          <el-option v-for="item in villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
        </el-select>
        <el-input class="input" v-model.trim="villageName" disabled size="small" placeholder="小区名称" v-else></el-input>
        <el-select class="select" v-model="building" filterable clearable size="small" placeholder="楼栋" @change="changeSearchBuilding">
          <el-option v-for="item in buildingList" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
        <el-select class="select" v-model="unit" filterable clearable size="small" placeholder="单元">
          <el-option v-for="item in unitList" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
        <el-select class="select" v-model="stateValue" filterable clearable size="small" placeholder="状态">
          <el-option v-for="item in stateList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
        <div class="clearfix"></div>
      </div>
      <div style="margin-top: 8px;">
        <el-select class="select" v-model="ownerTypeValue" filterable clearable size="small" placeholder="业主类型">
          <el-option v-for="item in ownerTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
        <el-input class="input" v-model.trim="ownerName" size="small" placeholder="业主姓名"></el-input>
        <el-input class="input" v-model.trim="ownerCode" size="small" placeholder="身份证"></el-input>
        <el-input class="input" v-model.trim="phoneNumber" size="small" placeholder="联系电话"></el-input>
        <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
        <div class="clearfix"></div>
      </div>
      <el-table :data="ownerAttr" class="list" @selection-change="selectOwner">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="orgName" label="小区名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="building" label="楼栋" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.building }}栋
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单元" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.unit }}单元
          </template>
        </el-table-column>
        <el-table-column prop="room" label="房间" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="name" label="业主姓名" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="ownerStatus" label="状态" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="auditState toAudit" v-if="scope.row.ownerStatus === 0"></div>
            <div class="auditState auditPass" v-if="scope.row.ownerStatus === 1"></div>
            <div class="auditState uploadAgain" v-if="scope.row.ownerStatus === 2"></div>
            <span v-if="scope.row.ownerStatus === 0">待审核</span>
            <span v-if="scope.row.ownerStatus === 1">审核通过</span>
            <span v-if="scope.row.ownerStatus === 2">审核驳回</span>
          </template>
        </el-table-column>
        <el-table-column prop="ownerType" label="业主类型" min-width="180" :align="align">
          <template slot-scope="scope">
            <span v-if="scope.row.ownerType === 0">普通业主</span>
            <span v-if="scope.row.ownerType === 1">业主代表</span>
          </template>
        </el-table-column>
        <el-table-column prop="idCard" label="身份证" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="phone" label="联系电话" min-width="180" :align="align"></el-table-column>
        <el-table-column fixed="right" :min-width="minWidth" label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" v-if="villageId !== ''" @click="edit(scope.row.id)">编辑</el-button> -->
            <el-button type="text" size="small" v-if="scope.row.ownerType === 0 && scope.row.ownerStatus === 1 && villageId !== '' && funcData.indexOf('changeOwner') > -1" @click="changeOwnerType(scope.row.id, scope.row.building, scope.row.unit, scope.row.orgId, 1)">升为业主代表</el-button>
            <el-button type="text" size="small" v-if="scope.row.ownerType === 1 && scope.row.ownerStatus === 1 && villageId !== '' && funcData.indexOf('changeOwner') > -1" @click="changeOwnerType(scope.row.id, scope.row.building, scope.row.unit, scope.row.orgId, 0)">降为普通业主</el-button>
            <el-button type="text" size="small" v-if="scope.row.ownerStatus === 0 && villageId !== '' && funcData.indexOf('audit') > -1" @click="auditPass(scope.row.id)">审核通过</el-button>
            <el-button type="text" size="small" v-if="scope.row.ownerStatus === 0 && villageId !== '' && funcData.indexOf('audit') > -1" @click="auditBack(scope.row.id)">审核驳回</el-button>
            <el-button type="text" size="small" v-if="villageId !== '' && funcData.indexOf('delete') > -1" @click="remove(scope.row.id)">删除</el-button>
            <el-button type="text" size="small" :disabled="scope.row.ownerStatus !== 1" @click="detail(scope.row.id, scope.row.ownerId, scope.row.name, scope.row.orgId, scope.row.roomId)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="ownerCurr" :page-sizes="[10, 20, 50]" :page-size="ownerSize" :total="ownerTotal" @current-change="ownerCurrChange" @size-change="ownerSizeChange"></el-pagination>
    </el-main>
    <!-- 新增编辑业主弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="小区名称" prop="village" v-if="villageId === ''">
          <el-select class="select" v-model="form.village" filterable clearable size="small" placeholder="小区名称" @change="changeVillage">
            <el-option v-for="item in form.villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区名称" :required="true" v-else>
          <el-input v-model.trim="villageName" disabled placeholder="小区名称"></el-input>
        </el-form-item>
        <el-form-item label="楼栋" prop="building">
          <el-select class="select" v-model="form.building" filterable clearable placeholder="楼栋" @change="changeBuilding">
            <el-option v-for="item in form.buildingList" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单元" prop="unit">
          <el-select class="select" v-model="form.unit" filterable clearable placeholder="单元" @change="changeUnit">
            <el-option v-for="item in form.unitList" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层" prop="floor">
          <el-select class="select" v-model="form.floor" filterable clearable placeholder="楼层" @change="changeFloor">
            <el-option v-for="item in form.floorList" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房间" prop="room">
          <el-select class="select" v-model="form.room" filterable clearable placeholder="房间">
            <el-option v-for="item in form.roomList" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业主姓名" prop="ownerName">
          <el-input v-model.trim="form.ownerName" placeholder="业主姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="ownerCode">
          <el-input v-model.trim="form.ownerCode" placeholder="身份证号" :maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phoneNumber">
          <el-input v-model.trim="form.phoneNumber" placeholder="联系电话" :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="form.sex" filterable clearable placeholder="性别">
            <el-option v-for="item in form.sexList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 审核驳回弹出层 -->
    <el-dialog :visible.sync="auditBackDialog" :title="auditBackTitle" width="500px" :close-on-click-modal="false" @close="auditBackNotBtn">
      <el-form ref="auditBackForm" :model="auditBackForm" :rules="auditBackRules" label-width="100px" size="small">
        <el-form-item label="驳回备注" prop="remark">
          <el-input v-model.trim="auditBackForm.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="驳回备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="auditBackNotBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="auditBackLoading" @click="auditBackOkBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入错误信息弹出层 -->
    <el-dialog :visible.sync="infoDialog" :title="infoTitle" width="600px" :close-on-click-modal="false" @close="infoNotBtn">
      <el-table class="infoList" :data="infoList">
        <el-table-column prop="index" label="列表行数" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="info" label="错误信息" min-width="300" :align="align"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Owner',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      importOwnerUrl: this.$url + this.$api.owner_import, // 业主导入的地址
      myHeaders: {
        token: sessionStorage.getItem('token') // token数据
      },
      minWidth: '300', // 列表操作列最小宽度
      myLocation: window.location.origin, // 当前域名
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      building: '', // 楼栋下拉菜单选中value
      buildingList: [], // 楼栋下拉菜单
      unit: '', // 单元下拉菜单选中value
      unitList: [], // 单元下拉菜单
      stateValue: '', // 状态下拉菜单选中value
      stateList: [], // 状态下拉菜单
      ownerTypeValue: '', // 业主类型下拉菜单选中value
      ownerTypeList: [], // 业主类型下拉菜单
      ownerName: '', // 业主姓名查询输入框
      ownerCode: '', // 身份证查询输入框
      phoneNumber: '', // 联系电话查询输入框
      delStatus: true, // 批量删除按钮的状态
      auditPassStatus: true, // 审核通过按钮的状态
      auditBackStatus: true, // 审核驳回按钮的状态
      ownerAttr: [], // 业主列表
      ownerTotal: 0, // 业主总数
      ownerSize: 10, // 业主每页条数
      ownerCurr: 1, // 业主当前页数
      selectOwnerArr: [], // 选中的业主数组
      dialog: false, // 业主弹出层状态
      title: '', // 业主弹出层标题
      loading: false, // 业主弹出层确定按钮loading
      form: {
        ownerId: '', // 业主Id
        village: '', // 小区名称
        villageList: [], // 小区名称下拉框
        building: '', // 楼栋
        buildingList: [], // 楼栋下拉框
        unit: '', // 单元
        unitList: [], // 单元下拉框
        floor: '', // 楼层
        floorList: [], // 楼层下拉框
        room: '', // 房间
        roomList: [], // 房间下拉框
        ownerName: '', // 业主姓名
        ownerCode: '', // 身份证号
        phoneNumber: '', // 联系电话
        sex: '', // 性别
        sexList: [] // 性别下拉框
      },
      rules: {
        village: [
          {
            required: true,
            message: '请选择小区名称',
            trigger: 'change'
          }
        ],
        building: [
          {
            required: true,
            message: '请选择楼栋',
            trigger: 'change'
          }
        ],
        unit: [
          {
            required: true,
            message: '请选择单元',
            trigger: 'change'
          }
        ],
        floor: [
          {
            required: true,
            message: '请选择楼层',
            trigger: 'change'
          }
        ],
        room: [
          {
            required: true,
            message: '请选择房间',
            trigger: 'change'
          }
        ],
        ownerName: [
          {
            required: true,
            message: '请输入业主姓名',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('业主姓名由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        ownerCode: [
          {
            required: true,
            message: '请输入身份证号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]+$/
              if (!reg.test(value) || value.length < 18) {
                callback(new Error('身份证号由18位数字和英文字母组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        phoneNumber: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^1[3456789]\d{9}$/
              if (!reg.test(value) || value.length < 11) {
                callback(new Error('请输入正确的联系电话'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }
        ]
      },
      auditBackDialog: false, // 审核驳回弹出层状态
      auditBackTitle: '', // 审核驳回弹出层标题
      auditBackLoading: false, // 审核驳回弹出层确定按钮loading
      auditBackForm: {
        ownerId: '', // 业主Id
        remark: '' // 驳回备注
      },
      auditBackRules: {
        remark: [
          {
            required: true,
            message: '请输入驳回备注',
            trigger: ['blur', 'change']
          }
        ]
      },
      infoDialog: false, // 导入错误信息弹出层状态
      infoTitle: '导入错误信息', // 导入错误信息弹出层标题
      infoList: [], // 导入错误信息列表
      delOwnerRoomId: '', // 删除的业主房间关联Id
      emqTime: null, // emq超时定时器
      client: null, // MQTT对象
      host: this.$host, // MQTT地址
      port: this.$port, // MQTT地址端口号
      clientId: 'WEB:' + new Date().getTime().toString(), // MQTT对象Id，当前时间
      username: this.$store.state.user.username, // MQTT访问的用户名
      password: this.$store.state.user.password // MQTT访问的密码
    }
  },
  computed: {
    // 功能权限
    funcData () {
      let data = this.$store.state.menus.funcData
      let buttonArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].url === this.$store.state.menus.activeMenu) {
          buttonArr.push(data[i].funcBotton)
        }
      }
      return JSON.parse(JSON.stringify(buttonArr))
    }
  },
  mounted () {
    // 小区名称
    if (this.$store.state.user.villageId === '') {
      this.villageId = ''
      this.villageName = ''
      this.minWidth = '100'
    } else {
      this.villageId = this.$store.state.user.villageId
      this.villageName = this.$store.state.user.villageName
      this.minWidth = '300'

      // 获取楼栋下拉菜单
      this.$http.get(this.$api.building_list, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          for (let i = 0; i < data.data.data.length; i++) {
            this.buildingList.push({
              id: data.data.data[i],
              value: data.data.data[i] + '栋'
            })
            this.form.buildingList.push({
              id: data.data.data[i],
              value: data.data.data[i] + '栋'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }

    if (this.villageId === '') {
      // 获取小区名称下拉菜单
      this.$http.get(this.$api.village_list, {
        params: {
          pageSize: 9999,
          pageNum: 1
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.villageValue = data.data.list[0].id
          this.villageList = data.data.list
          this.form.villageList = data.data.list

          // 获取楼栋下拉菜单
          this.$http.get(this.$api.building_list, {
            params: {
              orgId: this.villageValue
            }
          }).then((res) => {
            let data = res.data

            if (data.data.success) {
              for (let i = 0; i < data.data.data.length; i++) {
                this.buildingList.push({
                  id: data.data.data[i],
                  value: data.data.data[i] + '栋'
                })
              }
            } else {
              this.$message({
                type: 'error',
                message: data.data.errMsg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
          // 获取业主列表
          this.getOwnerList(this.ownerCurr, this.ownerSize)
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    } else {
      // 获取业主列表
      this.getOwnerList(this.ownerCurr, this.ownerSize)
    }

    // 获取审核状态下拉框数据
    this.stateList = [
      {
        key: 0,
        value: '待审核'
      },
      {
        key: 1,
        value: '审核通过'
      }
    ]
    // 获取业主类型下拉框数据
    this.ownerTypeList = [
      {
        key: 0,
        value: '普通业主'
      },
      {
        key: 1,
        value: '业主代表'
      }
    ]
    // 获取性别下拉框数据
    this.form.sexList = [
      {
        key: 0,
        value: '女'
      },
      {
        key: 1,
        value: '男'
      }
    ]
  },
  methods: {
    getOwnerList (page, size) {
      let orgId = this.villageId
      if (orgId === '') {
        orgId = this.villageValue
      }

      this.$http.get(this.$api.owner_list, {
        params: {
          pageNum: page,
          pageSize: size,
          orgId: orgId,
          ownerStatus: this.stateValue,
          ownerType: this.ownerTypeValue,
          name: this.ownerName,
          idCard: this.ownerCode,
          phone: this.phoneNumber,
          building: this.building,
          unit: this.unit
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.ownerAttr = data.data.list
          this.ownerTotal = data.data.total
          this.ownerSize = size
          this.ownerCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getOwnerList(1, this.ownerSize)
    },
    add () {
      this.dialog = true
      this.title = '新增业主'
    },
    edit (id) {
      this.$http.get(this.$api.owner_detail, {
        params: {
          ownerEnrollId: id
        }
      }).then((res) => {
        let data = res.data

        if (data.code === 1) {
          this.form.ownerId = id
          this.form.village = data.data.owner.tenantId
          this.form.ownerName = data.data.owner.ownerName
          this.form.ownerCode = data.data.owner.idNum
          this.form.phoneNumber = data.data.owner.phoneNum
          this.form.sex = data.data.owner.sex
          this.dialog = true
          this.title = '编辑业主'
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    detail (id, ownerId, name, villageId, roomId) {
      this.$router.push('ownerDetail?ownerRoomId=' + id + '&ownerId=' + ownerId + '&ownerName=' + encodeURI(encodeURI(name)) + '&villageId=' + villageId + '&roomId=' + roomId)
    },
    remove (id) {
      this.delOwnerRoomId = id
      let formData = new FormData()
      formData.append('ownerRoomId', id)
      formData.append('status', '-1')
      formData.append('type', 0)

      this.$confirm('是否删除业主?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          method: 'post',
          url: this.$api.owner_remove,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            this.$message({
              message: '业主已删除',
              type: 'success',
              duration: 1000
            })
            this.getOwnerList(1, this.ownerSize)

            this.client = new window.Paho.MQTT.Client(this.host, Number(this.port), this.clientId)
            let options = {
              invocationContext: {
                host: this.host,
                port: this.port,
                path: this.client.path,
                clientId: this.clientId
              },
              useSSL: this.$useSSL,
              timeout: 10,
              keepAliveInterval: 60,
              cleanSession: true,
              userName: this.username,
              password: this.password,
              onSuccess: this.onConnectOwnerDel,
              onFailure: this.onFailure
            }
            this.client.connect(options)
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    onConnectOwnerDel () {
      console.log('连接成功')

      let params = {
        ownerRoomId: this.delOwnerRoomId,
        status: -1
      }
      let topic = '/TYPE00/' + this.delOwnerRoomId + '/notify'
      let send = {
        cmd: 'handler',
        params: params
      }
      console.log(topic)
      console.log(JSON.stringify(send))
      let message = new window.Paho.MQTT.Message(JSON.stringify(send))
      message.destinationName = topic
      message.qos = 1
      message.retained = false
      this.client.send(message)
    },
    onFailure () {
      console.log('连接失败')
    },
    templateOwner () {
      window.open(this.$url + this.$api.import_template + '?type=2')
    },
    uploadSuccess (res) {
      if (res.success) {
        if (res.data.length === 0) {
          this.$message({
            message: '导入业主成功',
            type: 'success',
            duration: 1000
          })
        } else {
          this.$message({
            message: '导入业主完成',
            type: 'success',
            duration: 1000
          })
          for (let i = 0; i < res.data.length; i++) {
            for (let k in res.data[i]) {
              this.infoList.push({
                index: k,
                info: res.data[i][k]
              })
            }
          }
          this.infoDialog = true
        }
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
          duration: 2000
        })
      }
      this.getOwnerList(this.ownerCurr, this.ownerSize)
    },
    uploadError () {
      this.$message({
        type: 'error',
        message: '导入业主失败',
        duration: 1000
      })
    },
    infoNotBtn () {
      this.infoDialog = false
      this.infoList = []
    },
    exportOwner () {
      let orgId = ''
      if (this.villageId === '') {
        orgId = this.villageValue
      } else {
        orgId = this.villageId
      }
      window.open(this.$url + this.$api.owner_export + '?orgId=' + orgId + '&ownerStatus=' + this.stateValue + '&ownerType=' + this.ownerTypeValue + '&name=' + this.ownerName + '&idCard=' + this.ownerCode + '&phone=' + this.phoneNumber + '&building=' + this.building + '&unit=' + this.unit)
    },
    changeOwnerType (id, building, unit, orgId, ownerType) {
      if (ownerType === 0) {
        this.$confirm('是否把该业主降为普通业主?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let formData = new FormData()
          formData.append('id', id)
          formData.append('ownerType', ownerType)
          formData.append('building', building)
          formData.append('unit', unit)
          formData.append('orgId', orgId)

          this.$http({
            method: 'post',
            url: this.$api.owner_Type,
            data: formData
          }).then((res) => {
            let data = res.data

            if (data.success) {
              this.$message({
                message: '业主已降为普通业主',
                type: 'success',
                duration: 1000
              })
              this.getOwnerList(this.ownerCurr, this.ownerSize)
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {})
      }
      if (ownerType === 1) {
        this.$confirm('是否把该业主升为业主代表?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let formData = new FormData()
          formData.append('id', id)
          formData.append('ownerType', ownerType)
          formData.append('building', building)
          formData.append('unit', unit)
          formData.append('orgId', orgId)

          this.$http({
            method: 'post',
            url: this.$api.owner_Type,
            data: formData
          }).then((res) => {
            let data = res.data

            if (data.success) {
              this.$message({
                message: '业主已升为业主代表',
                type: 'success',
                duration: 1000
              })
              this.getOwnerList(this.ownerCurr, this.ownerSize)
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {})
      }
    },
    auditBack (id) {
      this.auditBackDialog = true
      this.auditBackTitle = '审核驳回'
      this.auditBackForm.ownerId = id
    },
    auditPass (id) {
      this.$confirm('是否审核通过业主?', '提示', {
        confirmButtonText: '通过',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = new FormData()
        formData.append('id', id)
        formData.append('ownerStatus', 1)

        this.$http({
          method: 'post',
          url: this.$api.owner_status,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.$message({
              message: '业主已审核通过',
              type: 'success',
              duration: 1000
            })
            this.getOwnerList(this.ownerCurr, this.ownerSize)
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    changeSearchVillage (val) {
      this.building = ''
      this.unit = ''
      this.buildingList = []
      this.unitList = []
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.building_list, {
          params: {
            orgId: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.buildingList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '栋'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeSearchBuilding (val) {
      this.unit = ''
      this.unitList = []
      let myOrg = ''
      if (this.villageId === '') {
        myOrg = this.villageValue
      } else {
        myOrg = this.villageId
      }
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.unit_list, {
          params: {
            orgId: myOrg,
            building: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.unitList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '单元'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeVillage (val) {
      this.form.building = ''
      this.form.unit = ''
      this.form.floor = ''
      this.form.room = ''
      this.form.buildingList = []
      this.form.unitList = []
      this.form.floorList = []
      this.form.roomList = []
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.building_list, {
          params: {
            orgId: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.form.buildingList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '栋'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeBuilding (val) {
      this.form.unit = ''
      this.form.floor = ''
      this.form.room = ''
      this.form.unitList = []
      this.form.floorList = []
      this.form.roomList = []
      let myOrg = ''
      if (this.villageId === '') {
        myOrg = this.form.village
      } else {
        myOrg = this.villageId
      }
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.unit_list, {
          params: {
            orgId: myOrg,
            building: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.form.unitList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '单元'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeUnit (val) {
      this.form.floor = ''
      this.form.room = ''
      this.form.floorList = []
      this.form.roomList = []
      let myOrg = ''
      if (this.villageId === '') {
        myOrg = this.form.village
      } else {
        myOrg = this.villageId
      }
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.owner_floor_list, {
          params: {
            orgId: myOrg,
            building: this.form.building,
            unit: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.form.floorList.push({
                id: data.data.data[i],
                value: data.data.data[i] + '层'
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    changeFloor (val) {
      this.form.room = ''
      this.form.roomList = []
      let myOrg = ''
      if (this.villageId === '') {
        myOrg = this.form.village
      } else {
        myOrg = this.villageId
      }
      if (val !== '' && val !== null) {
        this.$http.get(this.$api.owner_room_list, {
          params: {
            orgId: myOrg,
            building: this.form.building,
            unit: this.form.unit,
            floor: val
          }
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            for (let i = 0; i < data.data.data.length; i++) {
              this.form.roomList.push({
                id: data.data.data[i].id,
                value: data.data.data[i].room
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    notBtn () {
      this.$refs.form.resetFields()
      this.loading = false
      this.form.ownerId = ''
      this.form.village = ''
      this.form.building = ''
      if (this.villageId === '') {
        this.form.buildingList = []
      }
      this.form.unit = ''
      this.form.unitList = []
      this.form.floor = ''
      this.form.floorList = []
      this.form.room = ''
      this.form.roomList = []
      this.form.ownerName = ''
      this.form.ownerCode = ''
      this.form.phoneNumber = ''
      this.form.sex = ''
      this.dialog = false
    },
    auditBackNotBtn () {
      this.$refs.auditBackForm.resetFields()
      this.auditBackDialog = false
      this.auditBackLoading = false
      this.auditBackForm.ownerId = ''
      this.auditBackForm.remark = ''
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true

          let formData = new FormData()
          formData.append('id', this.form.ownerId)
          formData.append('name', this.form.ownerName)
          formData.append('idCard', this.form.ownerCode)
          formData.append('phone', this.form.phoneNumber)
          formData.append('sex', this.form.sex)
          formData.append('roomId', this.form.room)
          formData.append('ownerRoomType', 0)

          if (this.form.ownerId === '') {
            this.$http({
              method: 'post',
              url: this.$api.owner_add,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '新增业主成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getOwnerList(this.ownerCurr, this.ownerSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
              this.loading = false
            }).catch((err) => {
              this.loading = false
              console.log(err)
            })
          } else {
            this.$http({
              method: 'post',
              url: this.$api.owner_edit,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '编辑业主成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getOwnerList(this.ownerCurr, this.ownerSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
              this.loading = false
            }).catch((err) => {
              this.loading = false
              console.log(err)
            })
          }
        } else {
          return false
        }
      })
    },
    auditBackOkBtn () {
      this.$refs.auditBackForm.validate((valid) => {
        if (valid) {
          this.auditBackLoading = true

          let formData = new FormData()
          formData.append('id', this.auditBackForm.ownerId)
          formData.append('ownerStatus', 2)
          formData.append('remark', this.auditBackForm.remark)

          this.$http({
            method: 'post',
            url: this.$api.owner_status,
            data: formData
          }).then((res) => {
            let data = res.data

            if (data.success) {
              this.$message({
                message: '业主已审核驳回',
                type: 'success',
                duration: 1000
              })
              this.auditBackNotBtn()
              this.getOwnerList(this.ownerCurr, this.ownerSize)
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
            this.auditBackLoading = false
          }).catch((err) => {
            console.log(err)
            this.auditBackLoading = false
          })
        } else {
          return false
        }
      })
    },
    ownerCurrChange (curr) {
      this.getOwnerList(curr, this.ownerSize)
    },
    ownerSizeChange (size) {
      this.getOwnerList(this.ownerCurr, size)
    },
    getAuditState (val) {
      for (let i = 0; i < this.stateList.length; i++) {
        if (val.toString() === this.stateList[i].key) {
          return this.stateList[i].value
        }
      }
    },
    getOwnerType (val) {
      for (let i = 0; i < this.ownerTypeList.length; i++) {
        if (val.toString() === this.ownerTypeList[i].key) {
          return this.ownerTypeList[i].value
        }
      }
    },
    getSex (val) {
      for (let i = 0; i < this.form.sexList.length; i++) {
        if (val.toString() === this.form.sexList[i].key) {
          return this.form.sexList[i].value
        }
      }
    },
    selectOwner (selection) {
      if (selection.length > 0) {
        this.delStatus = false
        this.selectOwnerArr = []
        for (let i = 0; i < selection.length; i++) {
          this.selectOwnerArr.push(selection[i].id)
        }
        // 判断审核通过按钮状态
        for (let i = 0; i < selection.length; i++) {
          if (selection[i].ownerStatus === 1 || selection[i].ownerStatus === 2) {
            this.auditPassStatus = true
            break
          }
          if (selection.length - 1 === i) {
            this.auditPassStatus = false
          }
        }
        // 判断审核驳回按钮状态
        for (let i = 0; i < selection.length; i++) {
          if (selection[i].ownerStatus === 2) {
            this.auditBackStatus = true
            break
          }
          if (selection.length - 1 === i) {
            this.auditBackStatus = false
          }
        }
      } else {
        this.delStatus = true
        this.auditPassStatus = true
        this.auditBackStatus = true
      }
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.ownerCurr - 1) * this.ownerSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.owner
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-left 20px
      width 160px
    .input
      float left
      margin-left 20px
      width 160px
    .searchBtn
      float left
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
        .auditState
          display inline-block
          width 16px
          height 16px
          background-repeat no-repeat
          background-size 100% 100%
          vertical-align sub
          &.toUpload
            background-image url('./to_be_uploaded.png')
          &.toAudit
            background-image url('./to_be_audited.png')
          &.auditPass
            background-image url('./success.png')
          &.uploadAgain
            background-image url('./error.png')
        .ownerType
          display inline-block
          width 16px
          height 16px
          background-repeat no-repeat
          background-size 100% 100%
          vertical-align sub
          &.owner
            background-image url('./owner.png')
          &.tenant
            background-image url('./tenant.png')
          &.propClean
            background-image url('./property.png')
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
        .el-upload
          width 96px
          height 96px
          line-height 96px
        .el-upload-list__item
          width 96px
          height 96px
        .uploadText
          display block
          height 32px
          margin-top -70px
          font-size 14px
          color #333
        .el-upload__tip
          width 208px
          line-height 22px
          font-size 14px
          color rgba(0, 0, 0, .45)
      .infoList
        width 100%
        thead
          tr, th
            padding 4px 0
            color #666
            background-color #fafafa
            .cell
                font-weight bold
        tbody
          tr, th
            color #333
        td
          padding 7px 0
        .cell
          line-height 26px
</style>



// WEBPACK FOOTER //
// src/components/user/owner.vue